import React from 'react';
import { Cpu, Cloud, Users, Code2, Server, Database, Sparkles } from 'lucide-react';
import { portfolioData } from '../data/portfolioData';

export const Services: React.FC = () => {
  const getIcon = (iconName: string) => {
    switch (iconName) {
      case 'Cpu': return <Cpu size={26} />;
      case 'Cloud': return <Cloud size={26} />;
      case 'Users': return <Users size={26} />;
      case 'Code2': return <Code2 size={26} />;
      case 'Server': return <Server size={26} />;
      case 'Database': return <Database size={26} />;
      default: return <Sparkles size={26} />;
    }
  };

  return (
    <section id="services" className="section services-section">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">
            <Sparkles size={14} />
            <span>Expertise & Services</span>
          </div>
          <h2 className="section-title">
            Architectural Solutions <span className="text-gradient">& Offerings</span>
          </h2>
          <p className="section-subtitle">
            Providing high-throughput backend architecture, dynamic frontend engineering, and technical leadership.
          </p>
        </div>

        <div className="services-grid">
          {portfolioData.services.map((service, index) => (
            <div key={index} className="service-card glass-card">
              <div className={`service-icon-box ${service.colorClass}`}>
                {getIcon(service.icon)}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-desc">{service.description}</p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .services-section {
          background: var(--bg-secondary);
          padding-top: 1.5rem;
        }

        .services-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
          gap: 2rem;
        }

        .service-card {
          padding: 2.25rem 1.75rem;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          transition: all 0.3s ease;
        }

        .service-card:hover {
          transform: translateY(-6px);
        }

        .service-icon-box {
          width: 54px;
          height: 54px;
          border-radius: var(--radius-md);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          margin-bottom: 1.5rem;
          box-shadow: var(--shadow-sm);
        }

        .accent-1 { background: linear-gradient(135deg, #6366f1, #4f46e5); }
        .accent-2 { background: linear-gradient(135deg, #06b6d4, #0891b2); }
        .accent-3 { background: linear-gradient(135deg, #ec4899, #db2777); }
        .accent-4 { background: linear-gradient(135deg, #10b981, #059669); }
        .accent-5 { background: linear-gradient(135deg, #f59e0b, #d97706); }
        .accent-6 { background: linear-gradient(135deg, #8b5cf6, #7c3aed); }

        .service-title {
          font-size: 1.25rem;
          font-weight: 700;
          color: var(--text-main);
          margin-bottom: 0.85rem;
        }

        .service-desc {
          font-size: 0.95rem;
          color: var(--text-muted);
          line-height: 1.65;
        }

        @media (max-width: 768px) {
          .services-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>
  );
};
